module.exports = __webpack_public_path__ + "static/media/md-funnel.6315ebed.svg";